module.exports = __webpack_public_path__ + "fonts/Material-Regular.1a889d42.woff2";